import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { isPlacaValida } from 'src/app/core/utils/utilities';
import {
  ICreateCarreta,
  IGetCarretaById
} from 'src/app/services/CarretaService/carreta.model';
import { CarretaService } from 'src/app/services/CarretaService/carreta.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { IGetTipoCarreta } from 'src/app/services/TipoCarretaService/tipoCarreta.model';
import { TipoCarretaService } from 'src/app/services/TipoCarretaService/tipoCarreta.service';
import Swal from 'sweetalert2';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-cadastro-carreta',
  templateUrl: './cadastro-carreta.component.html',
  styleUrls: ['./cadastro-carreta.component.scss']
})
export class CadastroCarretaComponent implements OnInit, AfterViewInit {
  private subscription$ = new Subscription();
  form: FormGroup;
  activeRoute: string = '';

  pkCarreta: number = 0;
  disabledCarreta: boolean = false;
  title: string = 'Cadastro de Carreta';
  isEditing: boolean = false;

  statusInput: boolean = false;
  guid = generateUUID();

  isLoading: boolean = false;

  tipoCarretaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  motoristaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    private tipoCarretaService: TipoCarretaService,
    private carretaService: CarretaService,
    private swalAlert: SwalAlertService
  ) {
    this.form = this._inicializarFormulario();
  }

  createPayload(): ICreateCarreta {
    return {
      TX_PLCA_CRRT: String(
        this.form.controls['TX_PLCA_CRRT'].value
      ).toUpperCase(),
      NU_STTS_CRRT: 1,
      FK_MTRT_EXTR: Number(this.form.controls['FK_MTRT_EXTR'].value)
    };
  }

  private _inicializarFormulario() {
    const idMotorista = localStorage.getItem('id') || '1'; //
    const form = this.fb.group({
      TX_PLCA_CRRT: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      NU_STTS_CRRT: this.fb.control(1),
      FK_MTRT_EXTR: this.fb.control(Number(idMotorista))
    });
    return form;
  }

  postarDados() {
    const payload = this.createPayload();

    if (this.form.valid) {
      const placaValida = isPlacaValida(
        this.form.controls['TX_PLCA_CRRT'].value
      );
      if (placaValida) {
        this.isLoading = true;
        if (this.title.includes('Editar')) {
          this.carretaService.EditarCarreta(this.pkCarreta, payload).subscribe(
            response => {
              this.isLoading = false;
              this.router.navigate(['motorista-externo/listagem/carreta']);
            },
            error => {
              this.isLoading = false;
            }
          );
        } else if (this.title.includes('Cadastro')) {
          this.carretaService.CreateCarreta(payload, this.guid).subscribe(
            response => {
              this.isLoading = false;
              this.router.navigate(['motorista-externo/listagem/carreta']);
            },
            error => {
              this.isLoading = false;
            }
          );
        }
      } else {
        this.swalAlert.showAlert(
          'Atenção!',
          'Favor verificar se a placa informada está correta, pois possui apenas letras ou números.',
          'warning',
          false,
          false,
          undefined
        );
      }
    } else {
      this.swalAlert.showAlert(
        'Atenção!',
        'Verifique se todos os campos obrigatórios foram preenchidos corretamente.',
        'warning',
        false,
        false,
        undefined
      );
    }
  }

  getTipoCarreta() {
    this.isLoading = true;
    this.tipoCarretaService.GetTipoCarreta().subscribe(response => {
      this.isLoading = false;
      this.tipoCarretaOptions = response.map((x: IGetTipoCarreta) => {
        return {
          name: `${x.NM_TIPO_CRRT}`,
          value: x.PK_TIPO_CRRT
        };
      });
    });
  }

  exibirMensagem(mensagem: string, type: 'success' | 'error') {
    const config: MatSnackBarConfig = {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: type === 'success' ? ['snackbar-success'] : ['snackbar-error']
    };

    this.snackBar.open(mensagem, 'Fechar', config);
  }

  public goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  atualizarCampo(campo: string, valor: any): void {
    if (this.form.controls[campo].value !== valor) {
      this.form.controls[campo].setValue(valor);
    }
  }

  escolherOpcao(campo: string, options: any[], value: any): void {
    const selecionado = options.find(opcao => opcao?.value === Number(value));
    this.atualizarCampo(campo, selecionado?.value);
  }

  ngOnInit(): void {
    this.getTipoCarreta();
  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params && Object.keys(params).length > 0) {
        this.title = 'Editar carreta';
        this.isEditing = true;
        this.disabledCarreta = false;
        this.carretaService
          .GetCarretaById(Number(params['codigo']))
          .subscribe((response: IGetCarretaById) => {
            this.pkCarreta = response.PK_CRRT;
            this.form.controls['TX_PLCA_CRRT'].setValue(
              response.TX_PLCA_CRRT ?? 0
            );
          });

        if (params['modoCarreta'] == 'Visualizar') {
          this.title = 'Visualizar carreta';
          this.statusInput = true;
          this.disabledCarreta = true;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
